<template>
  <v-container fluid class="av-page">
    <div class="av-card av-panel">
      <div class="av-toolbar">
        <v-text-field
          v-model="tabela.busca"
          append-icon="search"
          label="Procurar"
          outlined
          dense
          hide-details
          single-line
          class="av-busca"
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn depressed color="primary" @click="abrirNovo">
          <v-icon left>add</v-icon>Nova empresa
        </v-btn>
      </div>

      <v-data-table
        :search="tabela.busca"
        :headers="tabela.cabecalho"
        :items="tabela.conteudo"
        sort-by="nome"
        class="av-table"
        :footer-props="{
          'items-per-page-text': 'Linhas por página',
          'items-per-page-all-text': 'Tudo',
        }"
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="editItem(item)">
                <v-icon small color="primary">mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon small v-on="on" @click="deleteItem(item)">
                <v-icon small color="error">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Excluir</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <div class="my-4">
            <p class="av-page-subtitle mb-2">Nenhuma empresa para exibir.</p>
            <v-btn small depressed color="primary" @click="carregaDados">
              <v-icon left small>refresh</v-icon>Recarregar
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="dialogoEmpresa" persistent max-width="900px" scrollable>
      <v-card>
        <v-card-title class="av-dialog-title">{{ formTitle }}</v-card-title>
        <p class="av-dialog-hint">* indica preenchimento obrigatório</p>
        <v-divider></v-divider>
        <v-card-text class="pt-4">
          <!-- Dados da empresa -->
          <span class="av-section-label">Dados da empresa</span>
          <v-row class="av-form-row">
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">Nome <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="editedItem.nome"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">CNPJ <span class="req">*</span></label>
              <v-text-field v-mask="'##.###.###/####-##'" outlined dense hide-details v-model="editedItem.cnpj"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">Endereço <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="editedItem.endereco"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">Telefone <span class="req">*</span></label>
              <v-text-field v-mask="'(##) #####-####'" outlined dense hide-details v-model="editedItem.telefone"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">E-mail</label>
              <v-text-field outlined dense hide-details v-model="editedItem.email"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">Data de Ativação</label>
              <v-text-field outlined dense hide-details v-model="editedItem.dataAtivacao" v-mask="'##/##/####'"></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="av-form-divider"></v-divider>

          <!-- Identidade visual -->
          <span class="av-section-label">Identidade visual</span>
          <v-row class="av-form-row">
            <v-col cols="12" md="6">
              <label class="av-field-label">Avatar URL <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="editedItem.avatarUrl"></v-text-field>
              <div class="av-img-preview" v-if="editedItem.avatarUrl">
                <v-img contain :src="editedItem.avatarUrl" height="100" max-width="160"></v-img>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <label class="av-field-label">Logo URL <span class="req">*</span></label>
              <v-text-field outlined dense hide-details v-model="editedItem.logoUrl"></v-text-field>
              <div class="av-img-preview" v-if="editedItem.logoUrl">
                <v-img contain :src="editedItem.logoUrl" height="100" max-width="160"></v-img>
              </div>
            </v-col>
          </v-row>

          <v-divider class="av-form-divider"></v-divider>

          <!-- Integração WhatsApp -->
          <span class="av-section-label">Integração WhatsApp</span>
          <v-row class="av-form-row">
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">&nbsp;</label>
              <div class="av-switch-field">
                <v-checkbox
                  v-model="editedItem.enviaWhatsApp"
                  :label="editedItem.enviaWhatsApp ? 'Envia WhatsApp' : 'Não envia WhatsApp'"
                  dense
                  hide-details
                  class="av-check ma-0 pa-0"
                ></v-checkbox>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">Integração</label>
              <v-select
                outlined
                dense
                hide-details
                clearable
                :items="integracoesWhatsApp"
                v-model="editedItem.apiWhatsApp"
                placeholder="Selecione a integração"
              ></v-select>
            </v-col>
          </v-row>

          <!-- Campos da integração selecionada -->
          <v-row v-if="editedItem.apiWhatsApp === 'META'" class="av-form-row">
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">Phone Number ID</label>
              <v-text-field outlined dense hide-details v-model="editedItem.metaPhoneNumberId"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">WABA ID</label>
              <v-text-field outlined dense hide-details v-model="editedItem.metaWabaId"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">API Version</label>
              <v-text-field outlined dense hide-details v-model="editedItem.metaApiVersion"></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">Token</label>
              <v-text-field outlined dense hide-details v-model="editedItem.metaToken"></v-text-field>
            </v-col>
          </v-row>

          <v-row v-else-if="editedItem.apiWhatsApp === 'ZAPI'" class="av-form-row">
            <v-col cols="12" md="4">
              <label class="av-field-label">Instância ID</label>
              <v-text-field outlined dense hide-details v-model="editedItem.zapiInstanciaID"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="av-field-label">Instância Token</label>
              <v-text-field outlined dense hide-details v-model="editedItem.zapiInstanciaToken"></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <label class="av-field-label">Client Token</label>
              <v-text-field outlined dense hide-details v-model="editedItem.zapiClientToken"></v-text-field>
            </v-col>
          </v-row>

          <v-row v-else-if="editedItem.apiWhatsApp === 'NEORON'" class="av-form-row">
            <v-col cols="12" sm="6" md="6" lg="6">
              <label class="av-field-label">API Key</label>
              <v-text-field outlined dense hide-details v-model="editedItem.neoronApiKey"></v-text-field>
            </v-col>
          </v-row>

          <v-row class="av-form-row">
            <v-col cols="12">
              <label class="av-field-label">Mensagem WhatsApp</label>
              <v-textarea outlined dense hide-details rows="3" v-model="editedItem.msgPesquisaWhatsApp"></v-textarea>
            </v-col>
          </v-row>

          <v-divider class="av-form-divider"></v-divider>

          <!-- Pesquisas -->
          <span class="av-section-label">Pesquisas</span>
          <v-row align="center" class="av-form-row">
            <v-col cols="12">
              <v-checkbox v-model="editedItem.expiraPesquisa" label="Expiração de Pesquisas" hint="As pesquisas de integração com o AI serão impedidas de receber respostas após o mês de sua criação." persistent-hint color="primary" class="mt-0"></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoEmpresa = false">Cancelar</v-btn>
          <v-btn depressed color="primary" @click="salvarEmpresa">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#2f7d74" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      integracoesWhatsApp: ['META', 'ZAPI', 'NEORON'],
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nome', },
          { text: 'CNPJ', value: 'cnpj' },
          { text: 'Telefone', value: 'telefone' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
      },
      dialogoEmpresa: false,
      editedIndex: -1,
      editedItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        telefone: '',
        logoUrl: '',
        avatarUrl: '',
        email: '',
        enviaWhatsApp: false,
        tokenWhatsApp: '',
        apiWhatsApp: '',
        msgPesquisaWhatsApp: '',
        zapiInstanciaID: '',
        zapiInstanciaToken: '',
        zapiClientToken: '',
        metaPhoneNumberId: '',
        metaToken: '',
        metaApiVersion: '',
        metaWabaId: '',
        neoronApiKey: '',
        dataAtivacao: '',
        expiraPesquisa: false,
      },
      defaultItem: {
        nome: '',
        cnpj: '',
        endereco: '',
        telefone: '',
        logoUrl: '',
        avatarUrl: '',
        email: '',
        enviaWhatsApp: false,
        tokenWhatsApp: '',
        apiWhatsApp: '',
        msgPesquisaWhatsApp: '',
        zapiInstanciaID: '',
        zapiInstanciaToken: '',
        zapiClientToken: '',
        metaPhoneNumberId: '',
        metaToken: '',
        metaApiVersion: '',
        metaWabaId: '',
        neoronApiKey: '',
        dataAtivacao: '',
        expiraPesquisa: false,
      },
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar nova empresa' : 'Editar empresa'
      },
    }),

    watch: {
      dialogoEmpresa(val) {
        if (val == false) {
          setTimeout(() => {
            this.editedItem = Object.assign({}, this.defaultItem)
          }, 300);
        }
      }
    },

    mounted() {
      this.carregaDados()
    },

    methods: {
      async carregaDados () {
        this.isLoading = true
        await axios.get(baseApiUrl + 'Empresas?filter={"order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'))
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
            this.isLoading = false
          }
        })
      },

      abrirNovo() {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, this.defaultItem)
        this.dialogoEmpresa = true
      },

      editItem (item) {
        this.isLoading = true
        this.editedIndex = this.tabela.conteudo.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogoEmpresa = true
        this.isLoading = false
      },

      async salvarEmpresa() {
        var vm = this;
        if (this.editedItem.nome || this.editedItem.cnpj || this.editedItem.endereco || this.editedItem.telefone || this.editedItem.logoUrl || this.editedItem.avatarUrl) {
          this.isLoading = true
          await axios.post(baseApiUrl + 'Empresas/replaceOrCreate?access_token=' + sessionStorage.getItem('accToken'), this.editedItem)
          .then(response => {
            if (response.data) {
              this.isLoading = false
              this.dialogoEmpresa = false
              vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "white")
              this.carregaDados()
            }
          })
          .catch(() => {
            vm.$refs.chamaSnackbar.snack("#FEC8C8", "Erro ao realizar operação", "#BF4554")
          })
        } else {
          vm.$refs.chamaSnackbar.snack("warning", "Preencha os campos para prosseguir", "white")
        }
      },

      async deleteItem(item) {
        var r = confirm('Realmente deseja EXCLUIR o cliente ' + item.nome + '?')
        if (r == true) {
          await axios.delete(baseApiUrl + 'Empresas/' + item.id + '?access_token=' + sessionStorage.getItem('accToken'))
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("success", "Operação realizada com sucesso!", "white")
            this.carregaDados()
          })
        }
      },
    },
  }
</script>

<!-- Estilos globais legados (mantidos para não afetar outras telas ainda não migradas) -->
<style>
  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>

<style scoped>
  .av-page {
    padding: 20px 24px;
  }

  .av-panel {
    padding: 16px 16px 8px;
  }

  .av-toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 8px;
    flex-wrap: wrap;
  }

  .av-busca { max-width: 280px; }

  @media (max-width: 599px) {
    .av-toolbar {
      flex-direction: column;
      align-items: stretch;
    }

    .av-toolbar .v-spacer {
      display: none;
    }

    .av-busca {
      max-width: none;
    }

    .av-toolbar .v-btn {
      width: 100%;
    }
  }

  .av-dialog-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--av-text);
    padding-bottom: 2px;
  }

  .av-dialog-hint {
    margin: 0;
    padding: 0 16px 12px;
    font-size: 13px;
    color: var(--av-text-soft);
  }

  .av-section-label {
    display: block;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .4px;
    text-transform: uppercase;
    color: var(--av-text-soft);
    margin: 4px 0 10px;
  }

  .av-field-label {
    display: block;
    font-size: 12.5px;
    font-weight: 500;
    color: #2c3a3a;
    margin-bottom: 6px;
  }

  .av-field-label .req {
    color: #c62828;
  }

  /* Fundo para preview de imagens (avatar/logo) */
  .av-img-preview {
    margin-top: 10px;
    padding: 12px;
    background: #f4f6f6;
    border: 1px solid var(--av-border);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Booleano com aparência de campo (igual ao "Ativo" em Usuários) */
  .av-switch-field {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.38);
    padding: 6px 12px;
    min-height: 40px;
  }

  ::v-deep .av-check .v-input__slot {
    margin: 0;
  }

  ::v-deep .av-check .v-input__control {
    min-height: auto;
  }

  ::v-deep .av-check .v-label {
    color: rgba(0, 0, 0, 0.7);
  }

  .av-form-divider {
    margin: 20px 0;
  }

  /* Respiro confortável entre os campos do formulário */
  ::v-deep .av-form-row > [class*="col"] {
    padding-top: 8px;
    padding-bottom: 8px;
  }

  /* Cabeçalho legível, sobrepondo o CSS global herdado das telas legadas */
  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th {
    color: var(--av-text-soft) !important;
    background: #f7f9f9;
    font-size: 12.5px;
    font-weight: 600;
    white-space: nowrap;
    border-bottom: 1px solid var(--av-border) !important;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > thead > tr > th,
  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    height: 46px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: 1px solid #eef1f1 !important;
    font-size: 13.5px;
  }

  ::v-deep .av-table .v-data-table__wrapper > table > tbody > tr:hover {
    background: #f5f8f8;
  }

  ::v-deep .av-table.v-data-table {
    background: transparent;
  }
</style>
